﻿import { createElement, onEvent } from "./_dom";
import { getMaxRequestLength } from "./context";
import { addScript, addScriptAsync } from "./addScript";
import * as fscorlib from "../fscorlib";

const floatingButtonPanelSelector = ".v3-header__menu2>.v3-layout__actions,#v3-popup-container>.v3-toolaction__menu";

var recordItemSelector = ".v3-tableview__group-row,.v3-timeline__group-row,.v3-tileview-item,.v3-kanbanview-item";

// universal value getter
function getValue(input) {
	if (input.tagName === "INPUT" && input.type === "radio") {
		let e = input.form.elements[input.name];
		if (e.tagName) e = [e];
		for (let i = 0; i < e.length; i++)
			if (e[i].checked) return e[i].value;
	}
	if (input.tagName === "INPUT" && input.type === "checkbox") {
		const e = input.form.elements[input.name];
		if (e.tagName) return e.checked;
		const result = [];
		for (let i = 0; i < e.length; i++)
			if (e[i].checked) result.push(e[i].value);
		return result;

	} else {
		return input.value;
	}
}
// universal value setter for SELECT, TEXTAREA, INPUT, INPUT[type=radio], INPUT[type=checkbox]
function setValue(input, value) {
	if (input.tagName === "SELECT") {
		value = value != null ? value.toString() : "";
		const options = input.options;
		for (let i = 0, l = options.length; i < l; i++) {
			if (options[i].value === value) {
				input.selectedIndex = i;
				return;
			}
		}
		input.selectedIndex = -1;
	} else if (input.tagName === "INPUT" && input.type === "radio") {
		value = value != null ? value.toString() : "";
		let e = input.form.elements[input.name];
		if (e.tagName) e = [e];
		for (let i = 0; i < e.length; i++) {
			e[i].checked = e.value === value;
		}
	} else if (input.tagName === "INPUT" && input.type === "checkbox") {
		const e = input.form.elements[input.name];
		if (e.tagName) {
			e.checked = Array.isArray(value) ? value.indexOf(input.value) >= 0 : !!value;
		} else {
			if (!Array.isArray(value))
				value = value != null ? [value] : [];
			for (let i = 0; i < e.length; i++) {
				e[i].checked = value.indexOf(input.value) >= 0;
			}
		}
	} else {
		input.value = value;
	}
}

// Loops through [id, value] pairs and set value. 
// Notifies first changed control
function setFormValues(/*id, value[, id, value...]*/) {
	var firstInput = null;
	for (var i = 0; i < arguments.length; i += 2) {
		const id = arguments[i];
		const value = arguments[i + 1];
		const input = document.getElementById(id);
		if (getValue(input) != value) {
			setValue(input, value);
			firstInput = firstInput || input;
		}
	}
	if (firstInput != null) {
		firstInput.dispatchEvent(new Event("change", { bubbles: true }));
	}
	return false;
}

function disableFormButtons(context, enable) {
	const selectorToDisable = "button,.v3-button";

	function disableAll(disabled) {
		const places = [context, document.querySelector(floatingButtonPanelSelector)];

		places.forEach(p => p?.querySelectorAll(selectorToDisable).forEach(e => {
			disabled ? e.setAttribute("disabled", "") : e.removeAttribute("disabled");
		}));
	}

	if (enable === undefined) {
		window.onbeforeunload = null;
	} else if (enable === false && window.onbeforeunload) {
		// if this is from link click, 5 sec should be enough to leave the page
		// so, reenable the buttons after a while if we are still on the page
		setTimeout(() => disableFormButtons(context, true), 5000);
	}
	const disabled = !enable;
	disableAll(disabled);
	if (disabled) {
		window.addEventListener("pageshow", () => disableAll(false));
	}
}

function doConfirm(confirm, event) {
	const result =
		// do not ask if confirm is falsy, but not empty string -- empty string means default confirmation message
		!confirm && confirm !== "" ||
		window.confirm(typeof confirm === "string" && confirm !== "" ? confirm : "Are you sure?");
	if(event != null) {
		if (!result) {
			event.preventDefault();
			return false;
		}
		return;
	}
	return result;
}

function findLabel(e) {
	return e.closest("dl[id$=\"_label\"], td[id$=\"_value\"],div[id$=\"_value\"]");
}

function hasValue(e) {
	if (!e.form || !e.name) return;
	var controls = e.form.elements[e.name];
	if (controls instanceof Element)
		controls = [controls];
	for (let i = 0; i < controls.length; i++) {
		const e = controls[i];
		if ((e.tagName !== "INPUT" ||
			e.type !== "checkbox" && e.type !== "radio" ||
			e.checked) &&
			e.value !== "")
			return true;
	}
	return false;
}

function toggleInvalid(e, toggle) {
	var lbl = findLabel(e);
	if (lbl) {
		// control itself is required or label is required and we are checking primary control
		var invalid = (e.hasAttribute("required") ||
			lbl.classList.contains("v3-state-required") && e.name === lbl.id.slice(0, -6))
			&& !hasValue(e);

		if (toggle) {
			lbl.classList.toggle("v3-state-invalid", invalid);
			if (!invalid) {
				lbl.querySelector("div.ui-alert.v3-popup")?.remove();
			}
		}
		else if (invalid)
			lbl.classList.add("v3-state-invalid");
	}
}


function toogleInvalidOnChange({ target }) {
	if (target.matches("input[name], select[name], textarea[name]"))
		toggleInvalid(target, true);
}

function init(ctx) {
	// var ctx = $(selector || "form.fs-form");

	// old stuff handled:

	/* 1. set-value-for
	ctx.on("click", "a.fs-setvaluefor", function (e) {
		e = $(e.target);
		var t = $(e.attr("href")), v = e.attr("data-value");
		if (v == null) v = e.text();
		if (t.val() !== v)
			t.val(v).trigger("change");
		return false;
	});
	*/
	/* 2. "focus-within" (highlight label when focus is on cell)
	ctx.on("focusin focusout", "input,select,textarea,button", function (e) {
		var el = $(e.target), lbl = findLabel(el);
		if (lteIE7) lbl = lbl.add(el);
		lbl.toggleClass("ui-focus", e.type === "focusin");
	});
	*/
	// on form init, check for required
	ctx.querySelectorAll("input[name], select[name], textarea[name]").forEach(e => {
		toggleInvalid(e, false);
	});
	ctx.closest("form.fs-form")?.addEventListener("change", toogleInvalidOnChange);
}

function checkSize(form, size) {
	if (size) {
		var actualSize = 0;
		var data = new FormData(form);
		for (const [k, v] of data.entries()) {
			actualSize += k.length + 2;
			actualSize += v instanceof Blob ? v.size : v.length;
		}
		return actualSize < size;
	}
}

function doSubmit(form, useDefault) {
	if (!useDefault) {
		// console.log("About to submit a form");
		const event = new SubmitEvent("submit", { cancelable: true });
		if (form.dispatchEvent(event)) {
			// console.log("Form submitted manually");
			form.submit();
		} else {
			// console.log("Form submission prevented");
		}
	}
	return useDefault;
}

function updateButtons(form, inputName) {
	var disabled = !form.querySelector("input[name=\"" + inputName + "\"][type=checkbox]:checked");
	form.querySelectorAll("button.fs-norecords").forEach(button => button.disabled = disabled);
}

function checkRows(source, name, state, subset) {
	name = name || "rowid";
	state = source.checked || !!state;
	const form = source.form; // source is checkbox
	subset = (subset || form).querySelectorAll("input[name=\"" + name + "\"][type=checkbox],input[type=checkbox].js-selectgroup");
	subset.forEach(checkbox => {
		if (checkbox !== source) {
			checkbox.checked = state;
			const parentCell = checkbox.closest(recordItemSelector);
			parentCell?.classList.toggle("v3-state-selected", state);
		}
	});
	updateButtons(form, name);
}

function markRows(f/*: HTMLFormElement*/, ids/*: Array<int>*/) {
	const name = "rowid";
	if (ids.length !== 0) {
		const rowIds = Array.from(f.querySelectorAll("input[type=checkbox][name=" + name + "]"));
		for (var i = 0; i < ids.length; i++) {
			const id = ids[i];
			const c = rowIds.find(cc => cc.value == id);
			if (c) {
				c.checked = true;
				c.closest(recordItemSelector).classList.add("v3-state-selected");
			}
		}
	}
	else {
		updateButtons(f, name);
	}
}

function postback(form, source, actions, confirm) {
	if (doConfirm(confirm)) {
		if (typeof actions === "string")
			actions = { postbackaction: actions };
		for (var k in actions) {
			var v = actions[k];
			if (k === "postbackanchor")
				v = form.name.substring(4) + "_" + v.toString();
			var elt = form.elements[k];
			if (elt == null) {
				elt = createElement("input", {name: k, type:"hidden"});
				form.insertBefore(elt, form.firstChild);
			}
			elt.value = v;
		}
		const maxRequestLength = getMaxRequestLength();
		if (checkSize(form, maxRequestLength) === false) {
			alert("Attached file(s) are too large\r\n\r\n" +
				"Total size of files to send to the server is limited to " + (maxRequestLength / (1024 * 1024)).toFixed(0) + "MB\r\n" +
				"* If you are attaching single file, compress it before sending.\r\n" +
				"* If you are attaching multiple files, consider making multiple modifications and attach files one by one.");
			return false;
		}
		return (form.doSubmitHook || doSubmit)(form, source?.matches("[type=submit]"));
	}
	return false;
}

function postbackSection(form, source, action, id, confirm) {
	return postback(form, source, { postbackaction: action, currentrowid: id, postbackanchor: "section_" + id }, confirm);
}

function postbackRow(form, source, action, id, confirm) {
	return postback(form, source, { postbackaction: action, currentrowid: id, postbackanchor: id }, confirm);
}

function postbackCell(form, source, action, id) {
	return postback(form, source, { postbackaction: action, currentcellid: id }, false);
}

const isMacOS = navigator.userAgent.indexOf('Mac OS X') >= 0;

function isNewTabClick(event) {
	return isMacOS ?
			/*Cmd+Click on mac*/event.metaKey === true :
			/*Ctrl+Click else */event.ctrlKey === true;
}

function getHash(href) {
	const n = href.indexOf("#");
	return n >= 0 ? href.substring(n + 1) : "";
}

function handleFormButtonClicks(target, event) {
	let nodef = false;
	// action buttons
	if (!target.disabled) {
		const form = target.form;
		const confirm = target.dataset.confirm;
		if (target.classList.contains("fs-action") || target.classList.contains("fs-multirowaction")) {
			nodef = !postback(form, target, target.value, confirm);
		} else if (target.classList.contains("fs-rowaction")) {
			nodef = !postbackRow(form, target, target.value, target.getAttribute("fs-rowid"), confirm);
		} else if (target.classList.contains("fs-sectionaction")) {
			nodef = !postbackSection(form, target, target.value, target.getAttribute("fs-rowid"), confirm);
		} else if (target.classList.contains("js-setupcol")) {
			// Customize View -- checked columns
			var checked = [];
			console.log(target.value);
			if (target.value === "update") {
				checked = [...form.querySelectorAll('input[name="showhidecolumn"][type=checkbox]:checked')].map(checkbox => checkbox.value);
				console.log(checked);
			}
			postbackCell(form, target, "showhidecolumn", checked.join(","));
			nodef = true;
		}
	}
	if(nodef)
		event.preventDefault();
}

function handleFormCheckboxClicks(target) {
	if (target.name === "rowid") {
		target.closest(recordItemSelector).classList.toggle("v3-state-selected", target.checked);
		updateButtons(target.form, "rowid");
	}
	else if (target.classList.contains("js-selectall")) {
		checkRows(target, "rowid", false);
	}
	else if (target.classList.contains("js-selectgroup")) {
		const groupSet = target.closest("tbody").nextElementSibling;
		checkRows(target, "rowid", false, groupSet);
	}
}

function handleFormLinkClicks(target, event) {
	// various button-like links
	let nodef = true;
	if (!target.hasAttribute("disabled")) {
		const form = target.dataset.form ? document.getElementById(target.dataset.form) : target.closest("form");
		const confirm = doConfirm(target.dataset.confirm, event);
		nodef = confirm !== undefined;
		if (confirm !== false && target.matches("a.fs-action:not([target]):not([download]):not([data-download])")) {
			// disable link only if it is like-button
			// does not open in a new frame
			// and does not download
			disableFormButtons(form);
		}
		if (!nodef) {
			if (target.classList.contains("fs-action") || target.classList.contains("fs-multirowaction")) {
				postback(form, target, getHash(target.href));
				nodef = true;
			}
			else if (target.classList.contains("js-cellaction")) {
				// sort in table views
				postbackCell(form, target, target.name, getHash(target.href));
				nodef = true;
			}
		}
	}
	if (nodef) {
		event.preventDefault();
	}
}

function handleFormClick(event/*, form*/) {
	if (event.which === undefined || event.which === 1) {
		const target = event.target.closest("button,a,input[type=checkbox]");
		if (target) {
			if (target.matches("button")) {
				handleFormButtonClicks(target, event);
			} else if (target.matches("input[type=checkbox]")) {
				handleFormCheckboxClicks(target, event);
			} else if (target.matches("a") && !isNewTabClick(event)) {
				handleFormLinkClicks(target, event);
			}
		}
	}
}

function handleToolActionMenuClick(event) {
	handleFormLinkClicks(event.detail, event);
}

function onFormSubmit(e) {
	if (!e.defaultPrevented) {
		disableFormButtons(this);
	}
}

onEvent(document, "form.v3-form," + floatingButtonPanelSelector, "click", handleFormClick);
onEvent(document, ".v3-toolaction-button", "v3-toolaction.menuclick", handleToolActionMenuClick);

const FS = {
	addScript,
	addScriptAsync,

	...fscorlib,

	Form: {
		init,
		onSubmit: onFormSubmit,
		disableButtons: disableFormButtons,
		val: setFormValues,
		markRows,
		doSubmit
	}
};

function initSubmissionHandler(context, selector = "form.v3-form") {
	(context || document).querySelectorAll(selector).forEach(form => {
		form.addEventListener("submit", onFormSubmit);
	});
}

export { FS, initSubmissionHandler as init, setFormValues, postback, postbackCell };